// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import * as React from "react";
import {
    Card, CardContent, CardActions, TextField, makeStyles, Chip,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, Button, InputBase, Switch, Modal
} from '@material-ui/core';
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";

// let token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache(),
//     defaultOptions: {
//         watchQuery: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'ignore',
//         },
//         query: {
//             fetchPolicy: 'no-cache',
//             errorPolicy: 'all',
//         },
//     }
// });

const discountTypes = [
    {
        value: 'FINAL_PRICE',
        label: 'قیمت نهایی',
    },
    {
        value: 'PERCENT',
        label: 'درصدی',
    }
];

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
        width: '100%'
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    table: {
        minWidth: 650,
    }
}));

const productSeleceted = (productDiscount: Array<any>): Array<any> => {
    let result = []
    productDiscount.forEach((pd: any) => {
        if (pd.enable)
            result.push(pd.id)
    })
    console.log('productSeleceted: ', result);
    return result
}

const getProductDiscountMeta = (productDiscount: Array<any>): any => {
    let result = {}
    productDiscount.forEach((pd: any) => {
        if (pd.enable)
            result[pd.id] = Number(pd.discountValue);
    })
    console.log('getProductDiscountMeta: ', result)
    return result;
}

const getQueryParams = () => {
    let search = window.location.hash.split('?')[1]
    const params = new URLSearchParams(search)
    return params.getAll("id")[0]
}


export function DiscountEdit() {
    const classes = useStyles();
    const [discountType, setDiscountType] = React.useState('FINAL_PRICE');
    const [productDiscount, setProductDiscount] = React.useState<Array<any>>([]);
    const [rowsLoading, setRowsLoading] = React.useState(false);
    const [values, setValues] = React.useState({
        id: null,
        code: null,
        count: null,
        startDate: null,
        expiryDate: null,
        isEnabled: true,
        loading: true,
        tags: []
    });
    const [status, setStatus] = React.useState({ loading: false, message: '', hasError: false });

    async function getDiscount(discountId) {
        const GET_Discount = gql`
        query GetDiscount($where: DiscountWhereUniqueInput!){
            discount(where: $where){
              code
              count
              discountType              
              isEnabled
              meta
              products
              startDate
              expiryDate
              tags
            }
          }
      `;
        return await client.query({
            query: GET_Discount,
            variables: {
                where: {
                    id: discountId,
                },
            }
        }).then((res) => {
            let discountResult = res.data.discount;
            setDiscountType(discountResult.discountType)
            setValues({
                code: discountResult.code,
                count: discountResult.count,
                startDate: discountResult?.startDate?.substring(0, 10),
                expiryDate: discountResult?.expiryDate?.substring(0, 10),
                isEnabled: discountResult.isEnabled,
                id: discountId,
                loading: false,
                tags: discountResult.tags?.map((tag) => { return { key: tag.toUpperCase(), label: tag } })
            })
            return discountResult;
        })
    }

    async function getAllProducts(discount) {
        const GET_Products = gql`
        query Products($where: ProductWhereInput) {
            products(where: $where) {
              id
              title
              productType
            }
        }
      `;
        let result: Array<any> = await client.query({
            query: GET_Products,
            variables: {
                where: {
                    service: { equals: process.env.REACT_APP_SERVICE },
                    isEnabled: { equals: true }
                },
            }
        }).then((res) => {
            return res.data.products;
        })

        let pd = result.map((product: any) => {
            if (discount.meta[product.id])
                return { ...product, discountValue: discount.meta[product.id], enable: true }
            return { ...product, discountValue: '', enable: false }
        })

        console.log('pd: ', pd)
        setProductDiscount(pd)
        setRowsLoading(true)
    }

    const handleDiscountType = (event: any) => {
        console.log('handleDiscountType');
        setDiscountType(event.target.value);
    };

    const handleDeleteTag = (chipToDelete) => () => {
        setValues({ ...values, tags: values.tags.filter((tag) => tag.key !== chipToDelete.key) })
    };

    const handleAddTag = (e, newTagLabel) => {
        let existTag = values?.tags?.some(t => t.key === newTagLabel.toUpperCase())
        let newTags = [...values?.tags ?? [], { key: newTagLabel.toUpperCase(), label: newTagLabel }]
        if (!existTag && newTagLabel !== "")
            setValues({ ...values, tags: newTags })
    }

    const handlerEnabled = (productId: any) => {
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId)
                return { ...pd, enable: !pd.enable };
            return pd;
        })
        setProductDiscount(result)
    }

    const codeHandler = (value: any) => {
        console.log('codeHandler');
        setValues({ ...values, code: value })
    }

    const countHandler = (value: any) => {
        console.log('countHandler');
        setValues({ ...values, count: value })
    }

    const startDateHandler = (value: any) => {
        setValues({ ...values, startDate: value })
    }

    const expiryDateHandler = (value: any) => {
        console.log('expiryDate');
        setValues({ ...values, expiryDate: value })
    }

    const handlerDiscountValue = (value: any, productId: any) => { 
        let numericValue = Number(value);
        let result = productDiscount.map((pd: any) => {
            if (pd.id === productId) {
                if (discountType === 'PERCENT') {
                    if (numericValue < 1 || numericValue > 100) {
                        alert('مقدار درصد باید بین 1 تا 100 باشد');
                        return pd;
                    }
                }
                return { ...pd, discountValue: value };
            }
            return pd;
        })
        setProductDiscount(result);
    }

    const submitDiscount = async () => {
        setStatus({ message: '', loading: true, hasError: false })
        const CREATE_DISCOUNT = gql`
        mutation UpdateDiscount($where: DiscountWhereUniqueInput!, $data: DiscountUpdateInput!){
            updateDiscount(where: $where, data: $data){
                  id
            }
          }
          `;

        let data = {
            products: productSeleceted(productDiscount),
            count: Number(values.count),
            code: values.code,
            discountType: discountType,
            startDate: values.startDate,
            expiryDate: values.expiryDate,
            isEnabled: values.isEnabled,
            meta: getProductDiscountMeta(productDiscount), 
            tags: values.tags.map(tag => tag.label)
        }
        console.log('data request: ', data)
        let result: any = await client.mutate({
            mutation: CREATE_DISCOUNT,
            variables: {
                where: { id: values.id },
                data: data
            }
        }).then((res) => {
            console.log('submit: ', res.data)
            if (!res.data.errors) {
                setStatus({ loading: false, message: 'با موفقیت ثبت شد', hasError: false })
                window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/Discount`
                return res.data;
            }
            else {
                console.log('error: ', res.data)
                if (res.data.errors[0].message.includes("Unique constraint failed on the fields: (`code`)"))
                    setStatus({ loading: false, message: 'کد تخفیف تکراری است!', hasError: true })
                else
                    setStatus({ loading: false, message: 'خطا در ثبت!', hasError: true })

            }
        }).catch(e => {
            console.log('error catch: ', e)
            if (JSON.stringify(e).includes("Unique constraint failed on the fields: (`code`)"))
                setStatus({ loading: false, message: 'کد تخفیف تکراری است!', hasError: true })
            else
                setStatus({ loading: false, message: 'خطا در ثبت!', hasError: true })
        })
    }

    React.useEffect(() => {
        let discountId = getQueryParams()
        getDiscount(discountId)
            .then((res: any) => {
                getAllProducts(res);
            })

    }, [])

    return (
        <Card>
            <CardContent>
                {
                    !values.loading ?
                        <div style={{ display: "flex", flexDirection: 'column', marginBottom: '1rem' }}>
                            <div style={{ display: "flex", flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                                <TextField
                                    fullWidth
                                    label="نوع تخفیف"
                                    size="medium"
                                    id="outlined-select-currency-native"
                                    select
                                    onChange={(e: any) => handleDiscountType(e)}
                                    variant="outlined"
                                    value={discountType}
                                >
                                    {discountTypes.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </TextField>

                                <TextField fullWidth onChange={(e: any) => codeHandler(e.target.value)} value={values.code} size="medium" label="کد" variant="outlined"></TextField>

                                <TextField fullWidth onChange={(e: any) => countHandler(e.target.value)} value={values.count} label="تعداد" size="medium" type="number" variant="outlined"></TextField>


                            </div>
                            <div style={{ display: "flex", flexDirection: 'row', gap: '1rem', alignItems: 'center', marginBottom: '1rem', justifyContent: 'space-between' }}>
                                <TextField
                                    fullWidth
                                    onChange={(e: any) => startDateHandler(e.target.value)}
                                    label="تاریخ شروع"
                                    value={values.startDate}
                                    size="medium"
                                    id="todate"
                                    type="date"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />

                                <TextField
                                    fullWidth
                                    onChange={(e: any) => expiryDateHandler(e.target.value)}
                                    label="تاریخ پایان"
                                    value={values.expiryDate}
                                    size="medium"
                                    id="todate"
                                    type="date"
                                    variant="outlined"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                    <Switch
                                        checked={values.isEnabled}
                                        onChange={(e: any) => setValues({ ...values, isEnabled: !values.isEnabled })}
                                        color="primary"
                                        name="checkedA"
                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'row-reverse', gap: '1rem', alignItems: 'center' }}>
                                <div className={classes.root}>
                                    {values.tags?.map((data) => {
                                        return (
                                            <li key={data.key}>
                                                <Chip
                                                    label={data.label}
                                                    onDelete={handleDeleteTag(data)}
                                                    className={classes.chip}
                                                    variant="outlined"
                                                />
                                            </li>
                                        );
                                    })}

                                </div>
                                <TextField fullWidth onBlur={(e) => handleAddTag(e, e.target.value)} size="medium" label="تگ" variant="outlined"></TextField>
                            </div>
                        </div> :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem' }}>
                            <CircularProgress />
                        </div>
                }
                {
                    rowsLoading ?
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{ fontWeight: 700 }} align="center">محصول</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">شناسه</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">فعال/غیرفعال</TableCell>
                                        <TableCell style={{ fontWeight: 700 }} align="center">مبلغ نهایی</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {productDiscount.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell align="center">{row.title}</TableCell>
                                            <TableCell align="center">{row.id}</TableCell>
                                            <TableCell align="center">
                                                <Switch
                                                    checked={row.enable}
                                                    onChange={(e: any) => handlerEnabled(row.id)}
                                                    color="primary"
                                                    name="checkedA"
                                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                />
                                            </TableCell>
                                            <TableCell align="center">
                                                <InputBase
                                                    // value={row.value}
                                                    value={row.discountValue}
                                                    onChange={(e: any) => handlerDiscountValue(e.target.value, row.id)}
                                                    disabled={!row.enable}
                                                    style={{ textAlign: 'center' }}
                                                    placeholder={discountType === 'PERCENT' ? "درصد تخفیف را وارد کنید" : "مبلغ نهایی را وارد کنید"}
                                                    type="number"
                                                    inputProps={{ min: discountType === 'PERCENT' ? 1 : undefined, max: discountType === 'PERCENT' ? 100 : undefined }}
                                                />
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer> :
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem' }}>
                            <CircularProgress />
                        </div>
                }
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '2rem', justifyContent: 'space-between' }}>
                    <Button onClick={() => submitDiscount()} variant="contained" color="primary">ثبت</Button>
                    {
                        !status.loading && status.hasError && status.message ?
                            <section style={{ display: 'flex', backgroundColor: 'red', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {status.message}
                            </section>
                            :
                            <div></div>
                    }
                    {
                        !status.loading && !status.hasError && status.message ?
                            <section style={{ display: 'flex', backgroundColor: '#4fcc12', color: '#fff', padding: '5px', borderRadius: '8px', fontFamily: 'IranSans-Bold', fontSize: '14px', direction: 'rtl' }}>
                                {status.message}
                            </section>
                            :
                            <div></div>
                    }

                </div>
            </CardContent>
            <CardActions>

            </CardActions>
        </Card >
    )
}